import Cookies from "js-cookie";

// Note: HttpOnly cannot be set from client-side JavaScript (js-cookie/document.cookie) -
// it can only be applied via a Set-Cookie response header from the server. To reduce
// exposure, every cookie written through this utility defaults to Secure + SameSite=Strict
// unless the caller explicitly overrides them.
const DEFAULT_COOKIE_OPTIONS = {
  secure: true,
  sameSite: "strict"
};

export class CookieUtils {
  static get(name) {
    return Cookies.get(name);
  }

  static set(name, value, options) {
    Cookies.set(name, value, { ...DEFAULT_COOKIE_OPTIONS, ...options });
  }

  static remove(name) {
    Cookies.remove(name);
  }
}
